import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { segmentTrackAction, SegmentUserEvent } from 'app/middlewares/segment';

export const onPurchaseClick = (
): ThunkAction => (
    dispatch: Dispatch,
) => {
    dispatch(segmentTrackAction(SegmentUserEvent.DEMO_BUTTON_PURCHASE));
};
